import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

declare const Buffer: any;

@Injectable({
  providedIn: 'root'
})
export class CryptService {
  data: any = [
    {
      user: 'opsmgmt',
      password: '9qD9wnZN6Qf8nBpZ'
    }
  ];

  encrypt() {
    return CryptoJS.AES.encrypt(JSON.stringify(this.data), '28c870db-5b44-4e92-9b6e-dc619b3c2686').toString();
  }

  decrypt(auth: string) {
    var bytes = CryptoJS.AES.decrypt(auth, '28c870db-5b44-4e92-9b6e-dc619b3c2686');
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }

  encryptBy(encoded: any) {
    return CryptoJS.AES.encrypt(encoded, '28c870db-5b44-4e92-9b6e-dc619b3c2686').toString();
  }

  encryptArray(encoded: any) {
    return CryptoJS.AES.encrypt(JSON.stringify(encoded), '28c870db-5b44-4e92-9b6e-dc619b3c2686').toString();
  }

  decryptBy(encoded: string) {
    var decrypted = CryptoJS.AES.decrypt(encoded, '28c870db-5b44-4e92-9b6e-dc619b3c2686');
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
